import { ReactElement } from 'react'
import { GrayHeaderProps } from './props'
import * as S from './styled'

function GrayHeader ({ children }: GrayHeaderProps): ReactElement {
  return <S.Container>{children}</S.Container>
}

export default GrayHeader
